import mixitup from 'mixitup';
import tippy from 'tippy.js';

// Function to get tracking parameters from persistent storage
function getTrackingParameters() {
  // First check if parameters are available from PHP in window object
  if (window.siteTrackingParams) {
    return window.siteTrackingParams;
  }

  // Fallback to reading from cookies
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  };

  const cookieValue = getCookie('site_tracking_params');
  if (cookieValue) {
    try {
      return JSON.parse(decodeURIComponent(cookieValue));
    } catch (e) {
      console.error('Error parsing tracking cookie:', e);
    }
  }

  // Last resort: check current URL for parameters
  const urlParams = new URLSearchParams(window.location.search);
  const trackingParams = {};
  const paramsToTrack = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'gclid', 'gbraid', 'gad_source', 'gad_campaignid', 'fbclid', 'msclkid'
  ];

  paramsToTrack.forEach(param => {
    if (urlParams.has(param)) {
      trackingParams[param] = urlParams.get(param);
    }
  });

  return Object.keys(trackingParams).length > 0 ? trackingParams : null;
}

// Create jQuery plugin for flatpickr
if (typeof window.flatpickr !== 'undefined') {
  $.fn.flatpickr = function(options) {
    return this.each(function() {
      window.flatpickr(this, options);
    });
  };
}

// Fix for cookie policy plugin null reference error
$(document).ready(function() {
  // Override window.onerror to suppress specific cookie plugin errors
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    // Suppress the specific cookie policy getAttribute error and related issues
    if (message && (
        (message.includes('getAttribute') && source && (source.includes('main.js') || source.includes('cookie'))) ||
        (message.includes('Cannot read properties of null') && source && source.includes('main.js')) ||
        (source && source.includes('icaal-cookie-policy-public.js'))
    )) {
      // Silently suppress in production, log only in development
      // console.warn('Suppressed cookie policy plugin error:', message);
      return true; // Suppress the error
    }
    // Let other errors through
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Add error handling for missing DOM elements that plugins expect
  const originalQuerySelector = document.querySelector;
  document.querySelector = function(selector) {
    try {
      return originalQuerySelector.call(this, selector);
    } catch (e) {
      console.warn('Element not found:', selector);
      return null;
    }
  };

  // Ensure cookie preferences widget exists
  if (!document.getElementById('icaal-cookie-preferences-widget')) {
    console.warn('Cookie preferences widget not found - plugin may have issues');
  }
});

$(() => {
  $('#menu-header-menu li.menu-item-has-children').append(
    '<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><svg class="svg-inline--fa fa-chevron-down fa-w-14 w-1-5" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>'
  );

  $('#toolbar-mobile li.menu-item-has-children').append(
    '<div class="toggle lg:hidden absolute z-20 top-0 right-0 pl-1 pr-1-5 py-0-5"><svg class="svg-inline--fa fa-chevron-down fa-w-10 w-1-5" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>'
  );

  $('.nav-search-toggle.menu-item a').attr(
    'aria-label', 'Search icon with magnifying glass'
  );

  $('[name="products"]').click(function () {
    $(this).toggleClass('selected');

    var hiddenInput = $(this)
      .parent()
      .parent()
      .parent()
      .find('.products-input');
    var itemsSelected = $(this).parent().parent().parent().find('.selected');
    var dataAttributeArray = '';
    for (var i = 0; i < itemsSelected.length; i++) {
      dataAttributeArray += $(itemsSelected[i]).val() + ', ';
    }
    hiddenInput.val(dataAttributeArray.slice(0, -2));
  });

  //contact/report-issue/apply-trade forms
  $('.form-submit').on('click', function (e) {
    
    e.preventDefault();
    var $form = $(this).parent().parent().parent();
    var formType = $form.find('input[name=type]').val();
    var formName = $form.data('form-name');
    var $response = $form.find('.response');
    var $submit = $form.find('.submit');
    var data = new FormData();
    var $data = $form.serializeArray();
    var endpoint = 'leads';


    var $file = $form.find('input[type="file"]');
    // Apply default postcode value to order form submissions for existing trade customers
    // This only applies if they have a trade account number
    if ($form.data('form') == 'order-form') {
      var endpoint = 'orders';

      var $no_trade_account_number = $form.find(
        'input[name="no_trade_account_number"]'
      );
      if (!$no_trade_account_number.is(':checked')) {
        data.append('postcode', 'HD6 4BW');
        console.log(
          'User has no trade account number, postcode set to HD6 4BW'
        );
      }
    }
    $.each($data, function (index, field) {
      if (field.value.length > 0) {
        data.append(field.name, field.value);
      }
    });
    $submit.prop('disabled', true);
    $form.find('.form-submitting-spinner').removeClass('hidden');
    $response.empty();
    if ($file.length === 1 && $file[0].files.length === 1) {
      data.append('attachment', $file[0].files[0]);
    }
    if($(this).hasClass('captchaForm')){
      var captchaResponse = $form.find('input[name="cf-turnstile-response"]').val();
      if (!captchaResponse) {
        $response.html('<div class="alert alert-danger">Please complete the CAPTCHA.</div>');
        return;
      }
      data.append('cf-turnstile-response', captchaResponse);
    }
    if (
      ($form.data('form') == 'order-form' || formType == 'job-application') &&
      $('#file_upload').val() &&
      $('#file_upload').val().length == 0
    ) {
      $('#file_upload')
        .next('.invalid-feedback')
        .text('Please upload at least 1 file');
      $submit.prop('disabled', false);
    } else {
      // Production
      // var api_url = 'https://api.quickslide-dashboard.icaal.dev/';
      var api_url = 'https://api.quickslide.co.uk/';

      if(sessionStorage.getItem('icaal__referrer_url')) {
        data.append('icaal__referrer_url', sessionStorage.getItem('icaal__referrer_url'));
      }

    if(sessionStorage.getItem('icaal__quoting-engine-tracking')) {
      data.append('icaal__quoting_engine_tracking', sessionStorage.getItem('icaal__quoting-engine-tracking'));
    }

      // [WR] Add tracking parameters from persistent storage
      const trackingParams = getTrackingParameters();
      console.log("Tracking params: ", trackingParams);
      if (trackingParams && Object.keys(trackingParams).length > 0) {
        // Add individual tracking parameters
        for (const [key, value] of Object.entries(trackingParams)) {
          data.append(key, value);
        }

        // Also add as JSON for backward compatibility
        data.append('utm_data', JSON.stringify(trackingParams));

        console.log('Form submission includes tracking params:', trackingParams);
      }
      // END [WR]

      let dontSubmit = false

    // Basic client-side validation for required fields
     $form.find('input, textarea').each(
        function () {
            if ($(this).attr('required') && $(this).val() == '') {
              $(this).removeClass('is-valid').addClass('is-invalid');
              $(this).next('.invalid-feedback').text('This field is required');
              dontSubmit = true;
            } else {
              $(this).addClass('is-valid').removeClass('is-invalid');
              $(this).next('.invalid-feedback').empty();
            }
        });
      $form.find('select').each(
        function () {
          // if the selected option is disabled, treat as not selected
          if ($(this).attr('required') && ($(this).val() == '' || $(this).find('option:selected').is(':disabled'))) {
              $(this).removeClass('is-valid').addClass('is-invalid');
              $(this).next('.invalid-feedback').text('This field is required');
              dontSubmit = true;
            } else {
              $(this).addClass('is-valid').removeClass('is-invalid');
              $(this).next('.invalid-feedback').empty();
            }
        });

      const checkbox = $form.find(`input[type="checkbox"][data-requiredcheckbox="true"]`)
      if(checkbox.length && !checkbox.is(':checked')){
        checkbox.closest("label").find(".reqInfo").fadeIn()
        dontSubmit = true
        $submit.prop('disabled', false)
      }
      if(!dontSubmit)
      $.ajax({
        url: api_url + endpoint,
        method: 'post',
        contentType: false,
        processData: false,
        data: data,
      })
        .done(function (response) {
          if (formName != '') {
            let formName1 = formName.replace(/[^a-zA-Z0-9]/g, '_');
            let formName2 = formName1.substring(0, 33);
            gtag('event', 'submit_' + formName2, {
              event_category: 'Form',
              sector:getSector()
            });
          }

          $form.find('input').addClass('is-valid').removeClass('is-invalid');
          $form.find('.invalid-feedback').empty();
          $response.append(
            '<div class="alert alert-success">' + response.message + '</div>'
          );
          $submit.prop('disabled', true);
          $form.find('.form-submitting-spinner').addClass('hidden');

          if (typeof iDimensions !== 'undefinded') {
            iDimensions = 1;
          }

          if (formType === 'brochure-request') {
            location.assign(
              'https://www.quickslide.co.uk/help-support/resources/brochures/'
            );
          } else {
            $form[0].reset();
          }
        })
        .fail(function (response) {
          $form.find('input').addClass('is-valid').removeClass('is-invalid');
          $form.find('.invalid-feedback').empty();
          $submit.prop('disabled', false);
          $form.find('.form-submitting-spinner').addClass('hidden');
          var errors = response.responseJSON.errors;
          if (errors) {
            $form.find('input').addClass('is-valid').removeClass('is-invalid');
            $form.find('.invalid-feedback').empty();
            $submit.removeClass('btn-loading').prop('disabled', false);
            if (errors) {
              $form
                .find('input')
                .addClass('is-valid')
                .removeClass('is-invalid');
              $form.find('.invalid-feedback').empty();
              $.each(errors, function (index, value) {
                if (index.includes('details.')) {
                  index = index.replace('details.', '');
                  index = '"details[' + index + ']"';
                }
                $('[name=' + index + ']')
                  .addClass('is-invalid')
                  .removeClass('is-valid');
                $('[name=' + index + ']')
                  .next('.invalid-feedback')
                  .text(value);
              });
              $form.trigger('complete');
            }
          } else {
            $response.append(
              '<div class="alert alert-success">Your message was sent successfully</div>'
            );
            $form.trigger('success');
            $form.trigger('complete');
          }
        });
        else
        $submit.prop('disabled', false)
      return false;
    }
  });

  $('.icaal-contact-form #enquiry_nature').on('change', function () {
    let typeInput = $(this)
      .parents('.icaal-contact-form')
      .find('input[name="type"]');
    if ($(this).val() == 'Sales') {
      typeInput.val('sales-enquiry');
    } else if ($(this).val() == 'Payments & Accounts') {
      typeInput.val('accounts-enquiry');
    } else if ($(this).val() == 'Trade Counter') {
      typeInput.val('trade-counter-enquiry');
    } else if ($(this).val() == 'Aftersales') {
      typeInput.val('aftersales-enquiry');
    } else if ($(this).val() == 'HR') {
      typeInput.val('hr-enquiry');
    } else if ($(this).val() == 'Other') {
      typeInput.val('enquiry');
    }
  });

  $('.multiple-selector-item').on('click', function () {
    $(this).toggleClass('selected bg-primary text-white');
    var itemInclude = $(this)
      .parents('.multiple-selector')
      .find('.multiple-selector-item.selected');
    var dataAttributeArray = '';
    var dataAttributeString = '';
    for (var i = 0; i < itemInclude.length; i++) {
      dataAttributeArray += itemInclude[i].getAttribute('data-include') + ', ';
    }
    dataAttributeString = dataAttributeArray.slice(0, -2);
    $(this)
      .parents('.multiple-selector')
      .find('.multiple-selector-input')
      .val(dataAttributeString);
  });

  var timing = 200;

  // Marketing Support form

  $('.ms-popup-open').on('click', function() {
    $('.marketing-support-popup').fadeIn(400);
  });

  $('[data-name]').on('click', function () {
    const dataNameValue = $(this).attr('data-name');

    // Add classes to matching elements
    $('[data-include]').each(function () {
        if ($(this).attr('data-include') === dataNameValue) {
            $(this).addClass('selected bg-primary text-white');
        }
    });

    // Add the value to the input field
    const inputField = $('.multiple-selector-input');
    const currentValue = inputField.val();

    inputField.val(currentValue ? `${currentValue},${dataNameValue}` : dataNameValue);

  });

  $('.ms-popup-close').on('click', function() {
    $('.marketing-support-popup').fadeOut(400);
    $('[data-include]').removeClass('selected bg-primary text-white');
    $('.multiple-selector-input').val('');
  });

  // end Marketing Support form

  $(
    '#menu-header-menu > li.menu-item-has-children > .toggle, #toolbar-mobile li.menu-item-has-children > .toggle'
  ).click(function () {
    if ($(this).parent().hasClass('open')) {
      $(this)
        .parent()
        .parent()
        .find('li.menu-item-has-children')
        .removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this)
        .parent()
        .parent()
        .find('li.menu-item-has-children.open')
        .removeClass('open');
      $(this)
        .parent()
        .parent()
        .find('li.menu-item-has-children.open > .sub-menu')
        .slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $(
    '#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle, #toolbar-mobile li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle'
  ).click(function () {
    if ($(this).parent().hasClass('open')) {
      $(this)
        .parent()
        .parent()
        .find('li.menu-item-has-children')
        .removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this)
        .parent()
        .parent()
        .find('li.menu-item-has-children.open')
        .removeClass('open');
      $(this)
        .parent()
        .parent()
        .find('li.menu-item-has-children.open > .sub-menu')
        .slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  // Desktop nav
  $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(
    function () {
      if ($(window).innerWidth() > 991) {
        var target = $(this).find('> ul.sub-menu');
        var width = $(target).outerWidth();

        var right_of_screen = $(window).innerWidth();
        var right_of_parent = $(this).offset().left + $(this).outerWidth();
        var right_of_element = right_of_parent + width;

        if (right_of_screen > right_of_element) {
          $(target).css('transform', 'translateX(100%)');
          $(target).css('right', '0');
        } else {
          $(target).css('transform', 'translateX(-100%)');
          $(target).css('left', '0');
        }
      }
    }
  );

  $('.slick-banner').on('init', function () {
    var hiddenSlides = $('.slick-banner .hidden');
    if (hiddenSlides.length > 1) {
      $('.slick-banner .hidden').each(function (i, el) {
        $(el).removeClass('hidden');
      });
    } else {
      hiddenSlides.removeClass('hidden');
    }
  });

  $('.slick-slider').on('init', function () {
    $('.slick-slider').removeClass('flex');
    var allSlides = $('.slick-slider .slide');
    if (allSlides.length > 1) {
      $('.slick-slider .slide').each(function (i, el) {
        $(el).removeClass('w-full sm:w-1/2 lg:w-1/3');
      });
    } else {
      allSlides.removeClass('w-full sm:w-1/2 lg:w-1/3');
    }
    var hiddenSlides = $('.slick-slider .hidden');
    if (hiddenSlides.length > 1) {
      $('.slick-slider .hidden').each(function (i, el) {
        $(el).removeClass('hidden');
      });
    } else {
      hiddenSlides.removeClass('hidden');
    }
  });

  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          event.preventDefault();
          $('html, body').animate(
            {
              scrollTop: target.offset().top - 200,
            },
            1000,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });

  $('.form-set').hide();
  $('.form-set[data-set="1"]').show().addClass('active-step');

  var stepCount = $('.form-set').length;
  // console.log(stepCount); // Debug only
  $('.back-step').on('click', function (e) {
    e.preventDefault();
    if ($('.form-set[data-set="' + stepCount + '"]').hasClass('active-step')) {
      $('.next-step').show();
    }
    if ($('.form-set[data-set="2"]').hasClass('active-step')) {
      $('.back-step').addClass('hidden');
      $(this)
        .parents('.trade-partner-controls')
        .removeClass('justify-between')
        .addClass('justify-end');
    }
    var step = parseInt($('.active-step').data('set'));
    $('.form-set').hide().removeClass('active-step');
    $('.form-set[data-set="' + (step - 1) + '"]')
      .show()
      .addClass('active-step');
    console.log(step);
  });
  $('.next-step').on('click', function (e) {
    e.preventDefault();
    if ($('.form-set[data-set="1"]').hasClass('active-step')) {
      $('.back-step').removeClass('hidden');
      $(this)
        .parents('.trade-partner-controls')
        .removeClass('justify-end')
        .addClass('justify-between');
    }
    var step = parseInt($('.active-step').data('set'));
    $('.form-set').hide().removeClass('active-step');
    $('.form-set[data-set="' + (step + 1) + '"]')
      .show()
      .addClass('active-step');
    console.log(step);
    if ($('.form-set[data-set="' + stepCount + '"]').hasClass('active-step')) {
      $('.next-step').hide();
    }
  });

  // Slick
  $('.slick-banner').slick({
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  $('.slick-colour-options').slick({
    dots: true,
    arrows: false,
    fade: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    infinite: true,
  });

  $('.alt-content-slider').slick({
    dots: true,
    arrows: false,
    fade: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  $('.product-slider').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 3,
    slidestoScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide: true,
        },
      },
    ],
  });

  $('.product-slider-new').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    infinite: true,
    lazyload: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 180,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true,
        },
      },
    ],
  });

  $('.testimonial-slider').slick({
    dots: true,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  var options = {
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 3,
    slidestoScroll: 1,
    swipeToSlide: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    adaptiveHeight: true,

    responsive: [
      {
        breakpoint: 180,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  $('.product-gallery-slider').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 3,
    slidestoScroll: 3,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // my slick slider as constant object
  const mySlider = $('.slick-testimonials')
    .on('init', function (slick) {
      // on init run our multi slide adaptive height function
      multiSlideAdaptiveHeight(mySlider);
    })
    .on('beforeChange', function (slick, currentSlide, nextSlide) {
      // on beforeChange run our multi slide adaptive height function
      multiSlideAdaptiveHeight(mySlider);
    })
    .slick(options);

  // our multi slide adaptive height function passing slider object
  function multiSlideAdaptiveHeight(slider) {
    // set our vars
    let activeSlides = [];
    let tallestSlide = 0;

    // very short delay in order for us get the correct active slides
    setTimeout(function () {
      // loop through each active slide for our current slider
      $('.slick-track .slick-slide .inner', slider).each(function (_, item) {
        // add current active slide height to our active slides array
        activeSlides[_] = $(item).outerHeight();
      });

      // for each of the active slides heights
      activeSlides.forEach(function (item) {
        // if current active slide height is greater than tallest slide height
        if (item > tallestSlide) {
          // override tallest slide height to current active slide height
          tallestSlide = item;
        }
      });

      // set the current slider slick list height to current active tallest slide height
      // $('.slick-list', slider).height(tallestSlide);
      $('.slick-track .slick-slide .inner', slider).each(function (
        index,
        item
      ) {
        // add current active slide height to our active slides array
        $(item).outerHeight(tallestSlide);
      });
    }, 10);
  }

  // when window is resized
  $(window).on('resize', function () {
    // run our multi slide adaptive height function incase current slider active slides change height responsively
    multiSlideAdaptiveHeight(mySlider);
  });

  $('.testimonial-slider-new').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint to a more typical mobile breakpoint
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });

  $('.video-slider').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });

  $('.slick-installer').slick({
    dots: false,
    arrows: false,
    cssEase: 'ease-in-out',
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 400,
    infinite: true,
    slidesToShow: 2,
    slidestoScroll: 2,
    swipeToSlide: true,
    mobileFirst: true,
    breakpoints: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
    ],
  });

  $('#popup-swatch-slider').slick({
    dots: false,
    arrows: true,
    autoplay: true,
    slidesToShow: 6,
    prevArrow: $('#popArrowPrev'),
    nextArrow: $('#popArrowNext'),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  // Popup

  if (!sessionStorage.getItem('popup-dismissed')) {
    sessionStorage.setItem('popup-dismissed', 'false');
  }

  if (sessionStorage.getItem('popup-dismissed') === 'false') {
    setTimeout(function () {
      $('.popup').removeClass('popup-hidden');
    }, 2000);
  }

  $('.popup-close').click(function () {
    $('.popup').addClass('popup-hidden');
    sessionStorage.setItem('popup-dismissed', 'true');
  });

  $('.product-hub-tab').on('click', function () {
    $('.product-hub-tab').removeClass('active-tab');

    $(this).addClass('active-tab');
    var hubtab = $(this).data('hub-btn');

    $('.product-hub-list').hide();
    $('.product-hub-list[data-hub-list="' + hubtab + '"]').css(
      'display',
      'flex'
    );
    $('.product-hub').hide();
    $('.product-hub[data-hub="' + hubtab + '"]').show();
    $('.product-hub[data-hub="' + hubtab + '"] .product-objects')
      .first()
      .show();
  });

  $('.hub-list-item').on('click', function () {
    var hubitem = $(this).data('hub-item');
    $('.hub-list-item').removeClass('active-item');
    $(this).addClass('active-item');

    $('.product-objects').siblings().hide();
    $('.product-objects[data-objects="' + hubitem + '"]').css(
      'display',
      'flex'
    );
  });

  $('.options-btn').on('click', function (e) {
    $('.options-btn').removeClass('active-option');
    e.preventDefault();
    var option = $(this).data('option');

    $(this).addClass('active-option');
    $('.option-info').hide();
    $('.option-content').hide();

    $('.option-info[data-option-info="' + option + '"]').show();
    $('.option-content[data-option-area="' + option + '"]').show();
  });

  $('[data-hardware-colours-target]').on('click', function () {
    let target = $(this).data('hardware-colours-target');
    console.log('[data-hardware-colours="' + target + '"]');
    $('[data-hardware-items-group]').addClass('hidden');
    $('[data-hardware-colours="' + target + '"]').removeClass('hidden');
  });

  $('[data-hardware-colours-close]').on('click', function () {
    // let target = $(this).data('return-to');
    $('[data-hardware-colours]').addClass('hidden');
    $('[data-hardware-items-group]').removeClass('hidden');
  });

  $(document).ready(function () {
    $('.faq-copy').hide();
    $('.active-faq').children('.faq-copy').show();
  });

  $('.faq-title').on('click', function () {
    $('.faq-container').removeClass('active-faq');
    $('.faq-copy').hide();
    $(this).next('.faq-copy').show();
    $(this).parent('.faq-container').addClass('active-faq');
  });

  // Dynamically change title on filter click
  $('.faqFilter').on('click', function () {
    var filterName = $(this).data('name');
    $('#faqHeading').text(filterName);
  });

  if ($(window).innerWidth() > 991) {
    $('.mega-menu-tab').on('mouseover', function (e) {
      // Prevent conflicts with sector selection
      if ($(this).hasClass('sector-select-toggle')) {
        return;
      }

      e.preventDefault();
      var menuElement = $(this).children('a');
      var menu = menuElement.length > 0 ? menuElement.attr('title') : null;

      // Fallback: try to extract menu type from CSS classes
      if (!menu) {
        var classList = $(this).attr('class').split(/\s+/);
        for (var i = 0; i < classList.length; i++) {
          // Look for menu-windows or menu-doors patterns and extract the correct part
          if (classList[i].startsWith('menu-') && !classList[i].startsWith('menu-item')) {
            menu = classList[i].replace('menu-', '');
            break;
          }
        }
      }

      if (menu) {
        $('.mega-menu').removeClass('menu-show').hide();
        $('.mega-menu[data-menu="' + menu + '"]')
          .addClass('menu-show')
          .show();
        $('.product-menu-overlay-close').show();
      }
    });

    $('.product-menu-overlay-close').on('mouseover', function () {
      $('.mega-menu').removeClass('menu-show').hide();
    });
  }

  $('.slick-p').click(function () {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').click(function () {
    $(this).parent().prev().slick('slickNext');
  });

  // Mixitup
  if ($('.mix-container').length) {
    var mixer = mixitup('.mix-container');
    if (mixer) {
      console.log('mix');
    }
  }

  // Initialize MixItUp for tab filtering
  if ($('.mix-container-steps').length) {
    var mixer = mixitup('.mix-container-steps', {
        load: {
            filter: '.collection-times' // Default filter class
        }
    });

    if (mixer) {
        console.log('MixItUp initialized');
    }
  }

  // Share Button
  $('.page-share').click(function () {
    if (navigator.share) {
      navigator
        .share({
          title: 'Share This Page',
          url: window.location,
        })
        .then(() => {
          console.log('Thanks for sharing!');
        })
        .catch((err) => {
          console.log('Couldnt share because of', err.message);
        });
    } else {
      $('#panel-share').toggleClass('active');
      console.log('navigator.share not supported!');
    }
  });

  $('.panel-share-close').click(function () {
    $('#panel-share').removeClass('active');
  });

  // Mobile Nav
  $('#nav-primary-toggle').click(function () {
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
  });

  // template-forms
  $('.form .pane-submit-btn').click(function (e) {
    e.preventDefault();
    var active = $('.form').find('.pane.active');
    var activePane = $('.form').find('.pane').index(active);

    var pane = null;
    if ($(this).data('pane')) {
      pane = $(this).data('pane');
    }

    nextPanel(pane, activePane);
  });

  function nextPanel(pane, active) {
    var $form = $('.form');
    var $active = $form.find('.pane.active');
    var $next = $active.next('.pane');
    var increment = 1;

    if (pane != null) {
      $next = $form.find('.pane').eq(pane);
      increment = pane - $active.index();
    }

    $active.removeClass('active');

    $('#start-btn').css('display', 'block');
    $('#start-btn').attr('data-panelno', active);

    $('#prev-btn').css('display', 'block');
    $('#prev-btn').attr('data-panelno', active);

    $next.addClass('active');
  }

  $('#prev-btn').on('click', function () {
    var $form = $('.form');
    var $active = $form.find('.pane.active');
    var $prev = $active.prev('.pane');

    var $pane = $(this).attr('data-panelno');

    if ($pane != null) {
      console.log($pane);
      $prev = $form.find('.pane').eq($pane);

      if ($pane == 0) {
        $('#start-btn').css('display', 'none');
        $('#prev-btn').css('display', 'none');
      }
    } else {
      $('#start-btn').css('display', 'none');
      $('#prev-btn').css('display', 'none');
    }

    $('.options-btn').removeClass('active-option');

    $active.removeClass('active');
    $prev.addClass('active');
    console.log('prev variable: ', $prev);
    var $backValue = $prev.data('back');
    console.log('backval variable: ', $backValue);
    if ($backValue !== undefined) {
      $(this).attr('data-panelno', $backValue);
    } else {
      $(this).attr('data-panelno', null);
    }
  });

  $('#start-btn').on('click', function () {
    var $form = $('.form');
    var $panel = $form.find('.pane.panel');
    var $first = $panel.first('.pane');

    var $pane = $(this).attr('data-pane');

    if ($pane != null) {
      console.log($pane);
      $first = $form.find('.pane').eq($pane);
    }

    $panel.removeClass('active');
    $first.addClass('active');

    $('.options-btn').removeClass('active-option');
    $('#start-btn').css('display', 'none');
    $('#prev-btn').css('display', 'none');

    $(this).attr('data-panelno', null);
  });

  // Why Choose Us section accordion
  $('.why-choose-content [data-toggle="why-choose-content"]').on(
    'click',
    function () {
      $(this).find('.read').toggleClass('active');
      let target = $(this).data('content-target');
      $('.why-choose-content [data-content="' + target + '"]').toggleClass(
        'active'
      );
    }
  );

  // Tippy tooltips
  tippy('[data-tippy-content]', {
    theme: 'light',
    allowHTML: true,
  });

  $('[data-toggle="tab"]').on('click', function () {
    let target = $(this).data('target');
    $('[data-toggle="tab"]').removeClass(
      'bg-primary text-white border-primary'
    );
    $(this).addClass('bg-primary text-white');
    $('[data-tab]').addClass('hidden');
    $('[data-tab="' + target + '"]').removeClass('hidden');
  });

  $('[data-glass-type-target]').on('click', function () {
    let target = $(this).data('glass-type-target');
    $('[data-glass-type-target]').removeClass(
      'bg-primary text-white hover:bg-grey-darker'
    );
    $(this).addClass('bg-primary text-white hover:bg-grey-darker');
    $('[data-glass-type]').addClass('hidden');
    $('[data-glass-type="' + target + '"]').removeClass('hidden');
  });

  $('.accordion-item-title').on('click', function () {
    $(this)
      .parents('.accordion-item')
      .find('.accordion-item-content')
      .slideToggle();
  });

  // Order Forms

  $('#customer_type').on('change', function () {
    let submitButton = $('button.form-submit');
    if ($(this).val() == 'New Customer') {
      $('.new-customer-notice').removeClass('hidden');
    } else {
      $('.new-customer-notice').addClass('hidden');
    }
  });

  $('.requested_week_commencing_date').flatpickr({
    dateFormat: 'd/m/Y',
    minDate: 'today',
    enable: [
      function (date) {
        return date.getDay() === 1;
      },
    ],
  });

  $('.no-trade-account-number').on('change', function () {
    let form = $(this).closest('form');
    let accountNumber = form.find('input[name="trade_account_number"]');
    let address = form.find('.your-details-address');
    if ($(this).prop('checked') == true) {
      $(accountNumber).prop('disabled', true).val('');
      $(address).show().find('input').prop('disabled', false);
    } else {
      $(accountNumber).show().prop('disabled', false);
      $(address).hide().find('input').prop('disabled', true).val('');
    }
  });

  $('.billing-postcode').on('keyup', function () {
    $(this)
      .closest('form')
      .find('.postcode-match-from-billing')
      .val($(this).val());
  });

  $('.transom-drop-type-wrapper').on(
    'change',
    '.transom-drop-type',
    function () {
      if ($(this).val() == 'Other') {
        $(this)
          .closest('.window-dimensions-transom-drop-group')
          .find('.window-dimensions-transom-drop-other')
          .show()
          .find('input')
          .prop('disabled', false);
      } else {
        $(this)
          .closest('.window-dimensions-transom-drop-group')
          .find('.window-dimensions-transom-drop-other')
          .hide()
          .find('input')
          .prop('disabled', true);
      }
    }
  );

  // Bi-Fold door configurations
  $('.icaal-contact-form').on(
    'change',
    '.dimensions-bi-fold-door .product-width, .dimensions-bi-fold-door .product-height',
    function () {
      let dimensions = $(this).closest('.dimensions-bi-fold-door');

      if (
        dimensions.find('.product-width').val().length > 0 &&
        dimensions.find('.product-height').val().length > 0
      ) {
        $(this)
          .closest('.dimensions-bi-fold-door')
          .find('.bi-fold-configuration-pane-toggle')
          .prop('disabled', false);
      } else {
        $(this)
          .closest()
          .find('.bi-fold-configuration-pane-toggle')
          .prop('disabled', true);
      }
    }
  );

  $('.icaal-contact-form').on(
    'click',
    '.bi-fold-configuration-pane-toggle',
    function () {
      let dimensions = $(this).closest('.dimensions-bi-fold-door');
      let width = dimensions.find('.product-width').val();
      // let height = dimensions.find('.product-height').val();

      $(this).prop('disabled', true);

      $(this).next().find('[data-panes]').addClass('hidden');
      $(this)
        .next()
        .find('[data-panes]')
        .each(function () {
          if (
            width >= $(this).data('width-minimum') &&
            width <= $(this).data('width-maximum')
          ) {
            $(this).removeClass('hidden');
          }
        });

      $(this).next().removeClass('hidden');
    }
  );

  $('.icaal-contact-form').on('click', '[data-configuration]', function () {
    $(this)
      .closest('.dimensions-bi-fold-door')
      .find('.bi-fold-configuration-pane-toggle')
      .val($(this).data('configuration'));
    $(this).closest('.bi-fold-configuration-modal').addClass('hidden');
    $(this)
      .closest('.bi-fold-configuration-modal')
      .prev()
      .prop('disabled', false);
  });

  $('.icaal-contact-form').on(
    'click',
    '.bi-fold-configuration-modal-close',
    function () {
      $(this)
        .closest('.bi-fold-configuration-modal')
        .prev()
        .prop('disabled', false);
      $(this).closest('.bi-fold-configuration-modal').addClass('hidden');
    }
  );

  // Handle bespoke colour text inputs and available external/internal colour combinations
  $('.colour_external_colour').on('change', function () {
    let colourReference = $(this)
      .closest('form')
      .find('.bespoke_colour_reference_external');
    if (
      $(this).val().includes('Bespoke') ||
      $(this).val().includes('bespoke')
    ) {
      colourReference.prop('disabled', false).show();
    } else {
      colourReference.prop('disabled', true).hide().val('');
    }

    let internalSelect = $(this)
      .closest('form')
      .find('.colour_internal_colour');
    internalSelect.find('option[value]').hide().prop('disabled', true);
    let allows = $(this).find(':selected').data('allows');
    let allowed = allows.split(', ');
    $.each(allowed, function (index, value) {
      internalSelect
        .find('option[value="' + value + '"]')
        .show()
        .prop('disabled', false);
    });
  });

  $('.external-colour-limiter').on('change', function () {
    let internalSelect = $(this)
      .closest('form')
      .find('.internal-colour-limiter');
    internalSelect.find('option[value]').hide().prop('disabled', true);
    let allows = $(this).find(':selected').data('allows');
    let allowed = allows.split(', ');
    $.each(allowed, function (index, value) {
      internalSelect
        .find('option[value="' + value + '"]')
        .show()
        .prop('disabled', false);
    });
  });

  $('.magnetic_door_catch').on('change', function () {
    let colour = $(this).closest('form').find('.magnetic_door_catch_colour');
    if ($(this).prop('checked') == true) {
      colour.show().find('select').prop('disabled', false);
    } else {
      colour.hide().find('select').prop('disabled', true).val('');
    }
  });

  $('.additional_hardware_travel_restrictors').on('change', function () {
    let travelRestrictorFinish = $(this)
      .closest('form')
      .find('.travel-restrictor-finish');
    if ($(this).prop('checked') == true) {
      travelRestrictorFinish.show().find('select').prop('disabled', false);
    } else {
      travelRestrictorFinish
        .hide()
        .find('select')
        .prop('disabled', true)
        .val('');
    }
  });

  $('.accordion-toggle').on('click', function () {
    let target = $(this).data('target');
    $('.accordion-content[data-accordion="' + target + '"]').slideToggle();
  });

  $('.window_handle_style').on('change', function () {
    let styleInput = $(this);
    let pegStay = $(this)
      .closest('form')
      .find('.window_handle_matching_peg_stay');

    let styles = ['Monkey Tail', 'Tear Drop'];

    if (styles.includes(styleInput.val())) {
      pegStay.show().find('input').prop('disabled', false);
    } else {
      pegStay
        .hide()
        .find('input')
        .prop('disabled', true)
        .prop('checked', false);
    }

    let colourInput = $(this).closest('form').find('.window_handle_colour');
    colourInput.find('option[value]').hide().prop('disabled', true);
    let allows = $(this).find(':selected').data('allows');
    let allowed = allows.split(', ');
    if (!allowed.includes(colourInput.val())) {
      colourInput.find('option:first').prop('selected', true);
    }
    $.each(allowed, function (index, value) {
      colourInput
        .find('option[value="' + value + '"]')
        .show()
        .prop('disabled', false);
    });
  });

  $('.icaal-contact-form').on(
    'change',
    '.single-french-doors-door-configuration',
    function () {
      let hingeSide = $(this)
        .closest('.clone-item')
        .find('.single-french-doors-hinge-side');
      let handleConfiguration = $(this)
        .closest('form')
        .find('.single-french-doors-handle-configuration');
      let doorType = $(this)
        .closest('.clone-item')
        .find('.single-french-doors-door-type');
      let primaryDoor = $(this)
        .closest('.clone-item')
        .find('.casement-doors-primary-door');

      if ($(this).val() == 'Single') {
        hingeSide.show().find('select').prop('disabled', false);
        handleConfiguration.hide().find('select').prop('disabled', true);
        doorType.show().find('input, select').prop('disabled', false);
        primaryDoor.hide().find('select').prop('disabled', true).val('');
      } else if ($(this).val() == 'French') {
        hingeSide.hide().find('select').prop('disabled', true).val('');
        handleConfiguration.show().find('select').prop('disabled', false);
        doorType.hide().find('input, select').prop('disabled', true);
        primaryDoor.show().find('select').prop('disabled', false);
      }
    }
  );

  $('.icaal-contact-form').on(
    'change',
    '.single-french-doors-door-type-input',
    function () {
      let midrail = $(this)
        .closest('.clone-item')
        .find('.pvcu-casement-doors-midrail-height-from-bottom');
      let panel = $(this)
        .closest('.clone-item')
        .find('.single-french-doors-door-panel');
      let panelHardware = $(this)
        .closest('form')
        .find('.pvcu-single-french-doors-panel-door-hardware');
      let spacerBarColour = $(this)
        .closest('form')
        .find('.colours-pvcu-spacer-bar');
      let glazingBarsLeadWork = $(this)
        .closest('form')
        .find('.pvcu-casement-doors-glazing-bars-lead-work');

      if ($(this).val() == 'Panel') {
        midrail.hide().find('input').prop('disabled', true).val('');
        panel.show().find('input').prop('disabled', false);
        panelHardware.show().find('input').prop('disabled', false);
        spacerBarColour.hide().find('select').prop('disabled', true).val('');
        glazingBarsLeadWork
          .hide()
          .find('select')
          .prop('disabled', true)
          .val('');
      } else {
        midrail.show().find('input').prop('disabled', false);
        panel.hide().find('input').prop('disabled', true).val('');
        panelHardware
          .hide()
          .find('input')
          .prop('disabled', true)
          .prop('checked', false);
        spacerBarColour.show().find('select').prop('disabled', false);
        glazingBarsLeadWork.show().find('select').prop('disabled', false);
      }
    }
  );

  $('.icaal-contact-form .glazing_type').on('change', function () {
    let pas24 = $(this)
      .closest('form')
      .find('.pas-24-requires-laminated-glass');
    if (
      $(this).val().includes('Laminated') ||
      $(this).val().includes('laminated')
    ) {
      pas24.prop('disabled', false);
    } else {
      pas24.prop('disabled', true).prop('checked', false);
    }
  });

  $('.icaal-contact-form .integral_blinds').on('change', function () {
    let options = $(this).closest('form').find('.integral_blind_options');
    if ($(this).prop('checked') == true) {
      options.show().find('input').prop('disabled', false).val('');
    } else {
      options.hide().find('input').prop('disabled', true).val('');
    }
  });

  $('.pvcu_sliding_doors_add_midrail').on('change', function () {
    let midrailHeight = $(this)
      .closest('form')
      .find('.door_midrail_height_from_bottom');
    if ($(this).prop('checked') == true) {
      midrailHeight.prop('disabled', false).show();
    } else {
      midrailHeight.prop('disabled', true).val('').hide();
    }
  });

  $('.glazing_bar_type').on('change', function () {
    let glazingBarOption = $(this)
      .closest('form')
      .find('.glazing-bar-layout, .glazing-bar-position');
    if ($(this).val() == 'None') {
      glazingBarOption.hide().find('select').prop('disabled', true).val('');
    } else {
      glazingBarOption.show().find('select').prop('disabled', false);
    }
  });

  $('.delivery_address_same_as_billing').on('change', function () {
    if ($(this).prop('checked') == true) {
      $(this)
        .closest('form')
        .find('.form-step-delivery .delivery-address')
        .slideToggle()
        .find('input')
        .prop('disabled', true);
    } else {
      $(this)
        .closest('form')
        .find('.form-step-delivery .delivery-address')
        .slideToggle()
        .find('input')
        .prop('disabled', false);
    }
  });

  $(
    '.icaal-contact-form .form-pdf-submission input[name="no_trade_account_number"]'
  ).on('click', function () {
    $(
      '.icaal-contact-form .form-pdf-submission #pdf-submission-contact-details'
    ).slideToggle();
    $(
      '.icaal-contact-form .form-pdf-submission #pdf-submission-contact-details input'
    ).prop('disabled', function (i, val) {
      return !val;
    });
  });

  $('.dimensions-wrapper-aluminium-flat-rooflight').on(
    'change',
    '.dimensions-type-aluminium-flat-rooflight',
    function () {
      console.log('changed');
      if ($(this).val() == 'Bespoke') {
        $(this)
          .closest('.dimensions-group-aluminium-flat-rooflight')
          .find('.dimensions-aluminium-flat-rooflight')
          .show()
          .find('input')
          .prop('disabled', false)
          .val('');
      } else {
        $(this)
          .closest('.dimensions-group-aluminium-flat-rooflight')
          .find('.dimensions-aluminium-flat-rooflight')
          .hide()
          .find('input')
          .prop('disabled', true)
          .val('');
      }
    }
  );

  // Clone dimensions
  var iDimensions = 0;
  $('.clone-trigger').on('click', function () {
    iDimensions++;
    var form = $(this).closest('form');

    var clone = form.find('.clonee:first').clone();
    clone.appendTo(form.closest('form').find('.clone-parent'));
    clone.find('input').val('');
    var $cloneInput = clone.find('input, select');
    var $cloneID = clone.find('.clone-id');

    $cloneID.text(iDimensions + 1);

    $cloneInput.each(function () {
      if ($(this).attr('data-clone-i') != '') {
        let name = $(this).attr('data-clone-name');
        $(this).attr('name', 'dimensions[' + iDimensions + ']' + name);
        $(this).attr('data-clone-i', iDimensions);
      } else {
        let inputName = $(this).attr('name').slice(0, -1);
        inputName += iDimensions;
        $(this).attr('name', inputName);
      }
    });
  });

  // Remove Dimensions
  $(document).on('click', '.clone-remove', function () {
    $(this).closest('.clone-item').remove();
    iDimensions--;
  });

  // Custom file upload ui
  $('.icaal-contact-form .form-input-file').each(function () {
    var $input = $(this),
      $label = $input.next('label'),
      labelVal = $label.html();

    $input.on('change', function (e) {
      var fileName = '';

      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute('data-multiple-caption') || '').replace(
          '{count}',
          this.files.length
        );
      else if (e.target.value) fileName = e.target.value.split('\\').pop();

      if (fileName) {
        $label.removeClass('border-grey-lighter');
        $label.addClass('border-green');
        $label.find('span').html(fileName);
      } else {
        $label.html(labelVal);
        $label.removeClass('border-green');
        $label.addClass('border-grey-lighter');
      }
    });

    // Firefox bug fix
    $input
      .on('focus', function () {
        $input.addClass('has-focus');
      })
      .on('blur', function () {
        $input.removeClass('has-focus');
      });
  });

  // start of tabbed content

  $('.tabbed-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    infinite: false,
    speed: 400,
    draggable: false,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
  });

  // Custom slick dots
  $('.custom-slick-dot').on('click', function () {
    var dotIndex = $(this).index();
    $('.tabbed-slider').slick('slickGoTo', dotIndex);
  });

  $('.tabbed-slider').on('afterChange', function (event, slick, currentSlide) {
    $('.custom-slick-dot').removeClass('active');

    $('.custom-slick-dot').eq(currentSlide).addClass('active');
  });

  // end of tabbed content

  // Order form & resource download events
  $('[data-download-type]').on('click', function () {
    if ($(this).data('download-type') != '') {
      // gtag('event', 'Submit', {
      //   event_category: 'Form',
      //   event_label: $(this).data('download-type'),
      // });
    }
  });

  $('[data-toggle="team-contact"]').on('click', function () {
    let toggle = $(this).data('toggle');
    let type = $(this).data('contact-type');
    let email = $(this).data('team-email');
    let name = $(this).data('team-name');
    let target = $('[data-toggled-by="' + toggle + '"]');

    if (type == 'message') {
      $(target).find('form').attr('data-form', 'team-contact-message');
      $(target)
        .find('form')
        .attr('data-form-name', 'Meet the Team Send a Message');
      $(target).find('input[name="type"]').val('meet-the-team-message');
      $(target).find('input[name="to"]').val(email);
      $(target).find('input#team_member').val(name);
      $(target).find('[data-form-title]').text('Send a Message');
      $(target).find('[data-team-name]').text(name);

      $(target).find('#date-input-wrapper').addClass('hidden');
    } else if (type == 'callback') {
      $(target).find('form').attr('data-form', 'team-contact-callback');
      $(target).find('form').attr('data-form-name', 'Meet the Team Callback');
      $(target).find('input[name="type"]').val('meet-the-team-callback');
      $(target).find('input[name="to"]').val(email);
      $(target).find('input[name="team_member"]').val(name);
      $(target).find('[data-form-title]').text('Request a Callback');
      $(target).find('[data-team-name]').text(name);

      $(target).find('#date-input-wrapper').removeClass('hidden');

      function flatpickrWeekends(date) {
        return date.getDay() === 0 || date.getDay() === 6;
      }

      $('#date-input').flatpickr({
        dateFormat: 'd/m/Y',
        minDate: 'today',
        disable: [flatpickrWeekends],
        locale: {
          firstDayOfWeek: 1,
        },
      });
    }

    target.removeClass('hidden');
  });

  $('.modal-close').on('click', function () {
    $(this).parents('[data-toggled-by="team-contact"]').addClass('hidden');
  });

  $('.tabs .tab-navigation .btn').on('click', function () {
    let target = $(this).data('target');
    $(this)
      .closest('.tab-navigation')
      .find('.btn.active')
      .removeClass('active');
    $(this).addClass('active');
    $(this).closest('.tabs').find('.tab:not(.hidden)').addClass('hidden');
    $(this)
      .closest('.tabs')
      .find('.tab[data-tab="' + target + '"]')
      .removeClass('hidden');
  });

  $('.nav-search-toggle').on('click', function (e) {
    e.preventDefault();
    $('.nav-search-bar').toggleClass('active');
    $('.swp-input').val('')
    // $('.ais-SearchBox-form .ais-SearchBox-input').focus();
  });
  $('.search-submit.swp-button').on('click', function(e) {
    if (/^\s*$/.test($('.swp-input').val())) {
      e.stopPropagation()
      e.preventDefault()
      $('.searchwp-form-input-container').append(`
        <p class="absolute emptyWarning" style="top: .15rem;left: 50%; opacity:0; transform: translateX(-50%);border: 1px solid red;color: red;background: #ffeaea;padding: .5rem;transition: opacity .3s ease-out;">Please type a search query</p>
      `)
      const emptyWarning = $('.searchwp-form-input-container').find('.emptyWarning')
      emptyWarning.css('opacity', 1)
      setTimeout(() => {
        emptyWarning.fadeOut(200, function() { $(this).remove() })
      }, 2000)
    }
  })

  // New Get a Price page
  $('.btn.sector-select').on('click', function () {
    let target = $(this).data('target');
    $('.btn.sector-select').removeClass('active');
    $(this).addClass('active');

    $('.sector').hide();
    $('.sector[data-sector="' + target + '"]').show();
  });

  $('.product-select').on('click', function () {
    $('.current-product').html($(this).html());
    if (window.innerWidth < 768) {
      $('.accordion-product-selectors .accordion-item-content').slideToggle();
    }

    let target = $(this).data('target');
    $('.product-select').removeClass('active');
    $(this).addClass('active');

    $('.products .product').hide();
    $('.products .product[data-product="' + target + '"]').show();
  });

  $('.product-tabs-nav .product-tab-nav-item').on('click', function () {
    let parent = $(this).closest('.product');
    let target = $(this).data('target');

    parent
      .find('.product-tabs-nav .product-tab-nav-item')
      .removeClass('active');
    $(this).addClass('active');

    parent.find('.product-tabs .product-tab').removeClass('active');
    parent
      .find('.product-tabs .product-tab[data-tab="' + target + '"]')
      .addClass('active');
  });

  $('[data-modal-target]').on('click', function () {
    let target = $('[data-modal="' + $(this).data('modal-target') + '"]');

    target.removeClass('opacity-0 pointer-events-none');
    target.addClass('modal-active');
  });

  $('.modal-close').on('click', function () {
    $('[data-modal]').addClass('opacity-0 pointer-events-none');
    $('[data-modal]').removeClass('modal-active');
  });

  $('.btn-product-range-filter').on('click', function () {
    let parent = $(this).closest('.product-range-filters');
    let target = $(this).data('filters');
    console.log(target);
    parent.find('.btn-product-range-filter').removeClass('active');
    $(this).addClass('active');
    parent.find('.product-range-product').hide();
    parent.find('.product-range-product[data-filters="' + target + '"]').show();
  });

  // Diagram hotspot lines
  function resetHotspotLines() {
    $('.product-features-left-anchor').each(function () {
      var feature = $(this).data('feature');
      var hotspot = $(
        '.product-features-left-hotspot[data-feature="' + feature + '"]'
      );

      var anchorRightEdge = $(this).offset().left + $(this).outerWidth();
      var anchorCenterVertical = $(this).offset().top + $(this).outerHeight() / 2;
      var hotspotCenterHorizontal =
        $(hotspot).offset().left + $(hotspot).outerWidth() / 2;
      var hotspotCenterVertical =
        $(hotspot).offset().top + $(hotspot).outerHeight();

      var distanceX = Math.abs(anchorRightEdge - hotspotCenterHorizontal);
      var distanceY = Math.abs(anchorCenterVertical - hotspotCenterVertical);

      $(this)
        .find('.hotspot-line-horizontal')
        .css({
          width: distanceX - 1 + 'px',
        });

      $(this)
        .find('.hotspot-line-vertical')
        .css({
          height: distanceY + 'px',
          right: '-' + (distanceX - 1) + 'px',
        });

      if (anchorCenterVertical > hotspotCenterVertical) {
        $(this)
          .find('.hotspot-line-vertical')
          .css({
            transform: 'translateY(-100%)',
            height: anchorCenterVertical - $(hotspot).offset().top + 'px',
          });
      }
    });
  }
  resetHotspotLines();

  $(window).on('resize', function () {
    resetHotspotLines();
  });

  $('.product-features-right-anchor').each(function () {
    var feature = $(this).data('feature');
    var hotspot = $(
      '.product-features-right-hotspot[data-feature="' + feature + '"]'
    );

    var anchorLeftEdge = $(this).offset().left;
    var anchorCenterVertical = $(this).offset().top + $(this).outerHeight() / 2;
    var hotspotCenterHorizontal =
      $(hotspot).offset().left + $(hotspot).outerWidth() / 2;
    var hotspotCenterVertical =
      $(hotspot).offset().top + $(hotspot).outerHeight();

    var distanceX = Math.abs(anchorLeftEdge - hotspotCenterHorizontal);
    var distanceY = Math.abs(anchorCenterVertical - hotspotCenterVertical);

    $(this)
      .find('.hotspot-line-horizontal')
      .css({
        width: distanceX + 1 + 'px',
      });

    $(this)
      .find('.hotspot-line-vertical')
      .css({
        height: distanceY + 'px',
        left: '-' + (distanceX + 3) + 'px',
      });

    if (anchorCenterVertical > hotspotCenterVertical) {
      $(this)
        .find('.hotspot-line-vertical')
        .css({
          transform: 'translateY(-100%)',
          height: anchorCenterVertical - $(hotspot).offset().top + 'px',
        });
    }
  });

  function setCookie(cookieName, cookieValue, expirationDays) {
    var date = new Date();
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + date.toUTCString();
    document.cookie =
      cookieName + '=' + cookieValue + ';' + expires + ';path=/';
  }

  $('.sector-select-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var sector = $(this).data('sector');
    // console.log('Sector selected:', sector); // Debug only

    setCookie('sector', sector, 30);
    $('#sector-select').removeClass('active');
    setCookie('sector_overlay', 'hidden', 30);

    var link = window.location.href;
    var url = new URL(link)
    if (url.searchParams.has('sector')) {
      url.searchParams.delete('sector');
    }

    // Add a small delay to prevent conflicts with other event handlers
    setTimeout(function() {
      window.location.replace(url);
    }, 100);
  });
  function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookies = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookies.split(';');

    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return null;
  }

  $(document).ready(function () {
    if (getCookie('sector')) {
      $('#sector-select').removeClass('active');
    }
  });


  //Cat filter buttons are the top rank.
  //faqFilter are secondary rank
  //faq-container are the faqs which are hidden and shown based on filter selection

  // Handle filter visibility - and if "All" is selected show all faqs, otherwise show relevant secondary filters and faqs
  $('.cat-filter-button').on('click', function () {
    $('.cat-filter-button').removeClass('active');
    $(this).addClass('active');
    
    $('.faq-container').hide();
    const filter = $(this).data('filter-group');

    // If popular or all is selected hide secondary filters as they are not relevant
    if (filter === 'popular' || filter === 'all') {
      $('.secondary-filter').hide();
    } else {
      $('.secondary-filter').show();
    }

    // If "All" is clicked show all faqs
    if(filter === 'all') {
      $('.faq-container').show();
      return false;
    }
    
    //Check each secondary filter button and if its data parent matches the selected primary filter show it
    $('.secondary-filter button').each(function (index, item) {
        if ($(item).data('parent') === filter) {
          $(item).show();
        }
        else{
          $(item).hide();
        }
    });
    return false;
  });

  //Show only filtered faqs on secondary filter click
  $('.faqFilter').click(function () {
    $('.faqFilter').removeClass('active');
    $(this).addClass('active');
//    $('.secondary-filter').hide();
    
    return false;
  });

  $(document).ready(function () {
    // Get the container element
    var container = $('#faqFiltersContainer');

    if (container.length){
      // Get the offset position of the container
    var offset = container.offset().top;
    var maxOffset = $("footer").offset().top - container.outerHeight() - 132;

    // Add a scroll event listener
    $(window).scroll(function () {
      // Add the "fixed" class to the container when the user scrolls down past the container's original position
      if ($(window).scrollTop() > offset && $(window).width() > 768 && $(window).scrollTop() < maxOffset) {
        var toolbarHeight = $('#toolbar').height();
        var headerHeight = $('header .header-nav-primary').height();
        console.log(toolbarHeight + ' | ' + headerHeight);
        var totalHeight = toolbarHeight + headerHeight + 16;
        container
          .addClass('fixed left-0 right-0 z-50')
          .css('top', totalHeight + 'px');
      } else {
        // Remove the "fixed" class when the user scrolls back up or when the viewport width is less than or equal to 768 pixels
        container.removeClass('fixed');
      }
    });
    }
  });

  // Product banner help slider

  $('.product-help-slider').slick({
    dots: true,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  // Product banner help toggle

  $('.help-toggle').on('click', function () {
    $(this).toggleClass('active');
    $('.product-help-content').toggleClass('active');
  });

  // Product Features tabs

  $('[data-tab-button]').on('click', function () {
    // zoom image

    // Check if the element does not have the class 'no-zoom'
    if (!$(this).hasClass('no-zoom')) {
      const $zoomImg = $('.zoom-img');
      var zoomCoords = $(this).data('zoom-coords').split(',');
      var xCoord = parseFloat(zoomCoords[0]);
      var yCoord = parseFloat(zoomCoords[1]);

      var imgWidth = $zoomImg.width();
      var imgHeight = $zoomImg.height();

      console.log(imgWidth, imgHeight);

      var xPercent = xCoord;
      var yPercent = yCoord;

      // Set the button's data attribute with dynamic coordinates

      $zoomImg.css({
        'transform-origin': xPercent + '% ' + yPercent + '%',
        transform: 'scale(2.5)',
      });

    }

    // end zoom image

    let that = $(this);
    const parent = $(this).parent().parent().parent();

    $('.zoom-img').addClass('active');

    $('[data-tab-button]').removeClass('active');
    that.addClass('active');

    parent.find('[data-tab-content]').removeClass('active');

    parent.find('[data-tab-content]').each(function () {
      if ($(this).data('tab-content') === that.data('tab-button')) {
        $(this).addClass('active');
      }
    });

    $('.feature-hotspot').each(function (index, item) {
      $(item).removeClass('active');
      if (that.data('index') === $(item).data('index')) {
        $(item).addClass('active');
      }
    });
  });

  $('.close-tab').on('click', function () {
    $('[data-tab-button]').removeClass('active');
    $('[data-tab-content]').removeClass('active');
    $('.zoom-img').removeClass('active');

    $('.zoom-img').css({
      'transform-origin': 0 + '% ' + 0 + '%',
      transform: 'scale(1)',
    });
  });

  // End Features tabs

  // Hardware tabs

  $('[data-hardware-tab-button]').on('click', function () {
    // zoom image

    // const $zoomImg  = $('.zoom-img');
    // var zoomCoords = $(this).data('hardware-zoom-coords').split(',');
    // var xCoord = parseFloat(zoomCoords[0]);
    // var yCoord = parseFloat(zoomCoords[1]);

    // var imgWidth = $zoomImg.width();
    // var imgHeight = $zoomImg.height();

    // console.log(imgWidth,imgHeight)

    // var xPercent = (xCoord);
    // var yPercent = (yCoord);

    // // Set the button's data attribute with dynamic coordinates

    // $zoomImg.css({
    //   'transform-origin': xPercent + '% ' + yPercent + '%',
    //   'transform': 'scale(2.5)'
    // });

    // end zoom image

    $('.tabs-wrap').addClass('opacity-0');

    let that = $(this);
    const parent = $(this).parent().parent().parent();

    // $('.zoom-img-wrap').addClass('active');

    $('[data-hardware-tab-button]').removeClass('active');
    that.addClass('active');

    parent.find('[data-hardware-tab-content]').removeClass('active');

    parent.find('[data-hardware-tab-content]').each(function () {
      if (
        $(this).data('hardware-tab-content') ===
        that.data('hardware-tab-button')
      ) {
        $(this).addClass('active');

        // Find the 'option-popup' inside this tab content and get its height
        let optionPopupHeight = $(this).find('.option-popup').outerHeight();

        // Set the height of the active tab content based on 'option-popup' height
        $('.option-wrapper').height(optionPopupHeight);
      }
    });
  });

  $('.close-tab').on('click', function () {
    $('[data-hardware-tab-button]').removeClass('active');
    $('[data-hardware-tab-content]').removeClass('active');
    $('.zoom-img-wrap').removeClass('active');
    $('.tabs-wrap').removeClass('opacity-0');

    $('.zoom-img').css({
      'transform-origin': 0 + '% ' + 0 + '%',
      transform: 'scale(1)',
    });

    // Reset height when closing the tab
    $('.option-wrapper').css('height', 'auto');

  });

  // End Hardware tabs

  // Colour Tabbed Content

  $('[data-colour-tab-button]').on('click', function () {
    let that = $(this);
    const parent = $(this).parent().parent();

    $('[data-colour-tab-button]').removeClass('active');
    $(this, '[data-colour-tab-button]').addClass('active');

    parent.find('[data-colour-tab-content]').hide();

    parent.find('[data-colour-tab-content]').each(function () {
      if (
        $(this).data('colour-tab-content') === that.data('colour-tab-button')
      ) {
        $(this, '[data-colour-tab-content]').show();
      }
    });
  });

  // End Colour Tabbed Content

  $('.expander-btn').on('click', function () {
    $(this).toggleClass('opened');
    $(this)
      .closest('.expander-container')
      .find('.expandable-text')
      .toggleClass('opened');
  });

  $('.glazing-accordion-btn').on('click', function () {
    $(this).toggleClass('opened');
    $(this)
      .closest('.glazing-accordion')
      .find('.glazing-accordion-content')
      .toggleClass('opened');
  });

  $('.colour-btn').on('click', function () {
    $(this).toggleClass('active');
    $('.custom-table').toggleClass('active');
  });

  // Anchor Menu
  $(window).on('scroll', function () {
    var scrollFromTop = $(document).scrollTop();
    var windowHeight = $(window).height();
    var documentHeight = $(document).height();
    var scrollFromBottom = documentHeight - (scrollFromTop + windowHeight);

    if (scrollFromTop > 10 && scrollFromBottom > 300) {
      $('.anchor-menu').addClass('show');
    } else {
      $('.anchor-menu').removeClass('show');
    }
  });

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top + 300;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).innerHeight();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(window).on('resize scroll', function () {
    $('section').each(function () {
      var activeID = $(this).attr('id');
      if ($(this).isInViewport()) {
        $('.anchor-link').removeClass('active');
        $('a[href="#' + activeID + '"]').addClass('active');
      }
    });
  });

  $('.anchor-link').on('click', function () {
    $('.anchor-link').removeClass('active');
    $(this).addClass('active');
  });

  // banner image rotation

  // $('.input-range').on('input', function (e) {
  //   const image = $('.banner-image-rotation')
  //   const original_URl = `/wp-content/uploads/sliding-sash/1024/${e.target.value}.png`
  //   image.attr('src', original_URl)
  //   console.log(e.target.value)
  // })

  // $('.input-range').on('input', function (e) {
  //   const image = $('.banner-image-rotation')
  //   const productType = productContainer.data('product');
  //   const original_URl = `/wp-content/uploads/${productType}/1024/${e.target.value}.png`
  //   image.attr('src', original_URl)
  //   console.log(e.target.value)
  // })


$('.input-range').on('input', function (e) {
  const productContainer = $(this).closest('[data-product]');
  const productType = productContainer.data('product');
  const image = productContainer.find('.banner-image-rotation');
  const original_URL = `/wp-content/uploads/${productType}/1024/${e.target.value}.png`;
  image.attr('src', original_URL);
  console.log(`Updated Image: ${original_URL}`);
});

  // register popup

  $('.register-btn').on('click', function () {
    $('.trade-application-popup').removeClass('hidden');
    $('html').addClass('overlay');
  });

  $('.sablos-register-btn').on('click', function () {
    $('.sablos-registration-popup').removeClass('hidden');
    $('html').addClass('overlay');
  });

  $('.register-btn-close').on('click', function () {
    $('.trade-application-popup, .sablos-registration-popup').addClass('hidden');
    $('html').removeClass('overlay');
  });

  // usps popup
  $('.usp-btn-close').on('click', function () {
    $('.usp-popup').addClass('hidden');
    $('html').removeClass('overlay');
  });

  $('.usps-popup-btn').on('click', function () {
    const index = $(this).data('index');
    $('.usp-popup').each(function (_, item) {
      if ($(item).data('index') === index) {
        $('html').addClass('overlay');
        $(item).removeClass('hidden');
      }
    });
  });

  $('#slim_midrail').on('change', function() {
    if ($(this).is(':checked')) {
      console.log('aaa')
      $('#run_through_sash_horns').prop('checked', true);
      $('#run_through_sash_horns').prop('disabled', true);
    } else {
      $('#run_through_sash_horns').prop('disabled', false);
      // $('#run_through_sash_horns').prop('checked', false);
    }
  });

  if ($('.banner-video').length) {
    $('.banner-video')[0].play();
  }

  let wasThermalSelected = false;
  $('#glazingType').change(function() {
    if ($(this).val() === 'Standard') {
      if (wasThermalSelected) {
        $('#thermalUpgrade').prop('checked', true);
      }
      $('#thermalUpgrade').prop('disabled', false);
    } else if ($(this).val() === 'Laminated Acoustic') {
      // Save the state of thermal upgrade before disabling it
      wasThermalSelected = $('#thermalUpgrade').is(':checked');
      $('#thermalUpgrade').prop('checked', false).prop('disabled', true);
    }
  });
  function showAllSearchResults(that, e, trigger){
    const urlNow = new URL(window.location.href)
    urlNow.search = ''
    window.history.replaceState(null,'',urlNow.href)
    const goToResults = () => {
      let searchQuery = $(that).val().trim()
      window.location.replace('/search-results?query=/'+encodeURIComponent(searchQuery))
    }
    if(e.key === 'Enter' && trigger==='Enter')
      goToResults()
    else if(trigger==='click')
      goToResults()
  }
  // $('.ais-SearchBox-input').on('keydown',function(e){
  //   showAllSearchResults($(this),e,'Enter')
  // })
  // $('.searchwp_live_search').on('keydown',function(e){
  //   showAllSearchResults($(this),e,'Enter')
  // })
  $('.clickForAllResults').on('click',function(e){
    showAllSearchResults($('.searchwp_live_search'),e,'click')
  })


  // custom gtag click events on various links:
  $('a[href^="mailto:"]').on('click',function(){
    gtag('event', 'email_click', {
      'event_name': 'email_click',
      sector:getSector()
    })
  })

  $('a[href^="tel:"]').on('click',function(){
    gtag('event', 'phone_click', {
      'event_name': 'phone_click',
      sector:getSector()
    })
  })

  $('a[href^="https://api.whatsapp"]').on('click',function(){
    gtag('event', 'whatsapp_click', {
      'event_name': 'whatsapp_click',
      sector:getSector()
    })
  })

  $('a[href^="https://www.facebook"]').on('click',function(){
    gtag('event', 'facebook_click', {
      'event_name': 'social_media_fb',
      sector:getSector()
    })
  })

  $('a[href^="https://twitter"]').on('click',function(){
    gtag('event', 'twitter_click', {
      'event_name': 'social_media_twitter',
      sector:getSector()
    })
  })

  $('a[href^="https://www.instagram"]').on('click',function(){
    gtag('event', 'instagram_click', {
      'event_name': 'social_media_instagram',
      sector:getSector()
    })
  })

  $('a[href^="https://www.tiktok"]').on('click',function(){
    gtag('event', 'tiktok_click', {
      'event_name': 'social_media_tiktok',
      sector:getSector()
    })
  })

  $('a[href^="https://www.youtube"]').on('click',function(){
    gtag('event', 'youtube_click', {
      'event_name': 'social_media_youtube',
      sector:getSector()
    })
  })

  $('a[href^="https://www.linkedin"]').on('click',function(){
    gtag('event', 'linkedin_click', {
      'event_name': 'social_media_linkedin',
      sector:getSector()
    })
  })

});


